<template>
  <footer class="footer">
    <div class="footer-nav-wrap">
      <div class="inner">
        <ul class="footer-nav-list">
          <li><NuxtLink to="/pc/etc/company-introduction">회사소개</NuxtLink></li>
          <li class="active">
            <NuxtLink @click="handlePopup(HcTncKndCd.KND_1003)">개인정보처리방침</NuxtLink>
          </li>
          <li>
            <NuxtLink @click="handlePopup(HcTncKndCd.KND_1002)">전자금융거래이용약관</NuxtLink>
          </li>
          <li>
            <NuxtLink @click="handlePopup(HcTncKndCd.KND_1001)">서비스 이용약관</NuxtLink>
          </li>
          <li><NuxtLink to="/pc/notice/list">공지사항</NuxtLink></li>
        </ul>
      </div>
    </div>
    <div class="inner">
      <div class="footer-company-wrap">
        <div class="company-info-area">
          <img src="@/assets/images/pc/footer-logo.png" alt="로고" class="footer-logo" />
          <address>
            <p>(주)현대이지웰 대표이사 : 박종선</p>
            <p>서울시 서대문구 충정로 23 현대이지웰</p>
            <p>
              사업자번호 : 101-81-90575
              <NuxtLink to="http://www.ftc.go.kr/info/bizinfo/communicationViewPopup.jsp?wrkr_no=1018190575" target="_blank" rel="noopenner noreferrer">
              [사업자정보 확인]
              </NuxtLink>
              통신판매업신고 : 2022-서울 서대문-1450호
            </p>
            <p>홈페이지 문의 : 
              <a href="mailto:hcon@hyundaiezwel.com">hcon@hyundaiezwel.com</a>
            </p>
            <p>고객센터 : 02-2161-0880 (평일 09~18시)</p>
            <p>호스팅서비스 : (주)현대이지웰</p>
            <small>Copyright &copy;HYUNDAI EZWEL CO., LTD. All rights reserved.</small>
          </address>
        </div>
        <div class="compony-mark-area">
          <HconDropDown type="familyBox" defaultLabel="패밀리 사이트" :familyOptions="familyOptionList" />
          <ul class="certification-mark-list" v-if="false">
            
            <!-- TODO 추후에 인증마크 클릭 시 인증서 팝업 뜨도록 작업 => 인증 범위에 Hcon 부여받은 후 아래의 링크 사용 권장-->
             <!--https://img.ezwelfare.net/welfare_upload/popup/img/2020/05/2005222_cadmisms_popup.jpg-->
            <li>
              <button type="button" aria-label="정보보호관리체계인증(ISMS)" @click="ImageFileOpen('ISMS')">
                <img src="@/assets/images/pc/main-hcon/mark-isms.png" alt="정보보호관리체계인증(ISMS)"/>
              </button>
              <div class="tooltip">
                <span class="tooltip-tit">
                  정보보호관리체계인증(ISMS) 인증범위<br />
                  복지몰 서비스 운영(온라인복지몰, 웰트리,<br />
                  온누리전통시자, 이지웰pay, 지역몰, B2B몰)<br />
                </span>
                <span class="expiration-date">
                  유효기간 2022.12.21 ~ 2025.12.20
                </span>
              </div>
            </li>

            <!-- TODO 추후에 인증 범위에 Hcon 부여받은 후 아래의 링크 사용 권장-->
             <!--https://img.ezwelfare.net/welfare_upload/popup/img/2025/07/iso227001_popup.jpg-->
            <li>
              <button type="button" aria-label="ISO 27001 인증" @click="ImageFileOpen('ISO-27001')">
                <img src="@/assets/images/pc/main-hcon/mark-its.png" alt="ISO 27001 인증" />
              </button>
            </li>

            <!-- TODO 아이콘 오버 시 유효기간 풍선글 노출-->
            <li>
              <button type="button" aria-label="가족친화기업인증">
                <img src="@/assets/images/pc/main-hcon/mark-family.png" alt="가족친화기업인증"/>
              </button>
            </li>

            <!-- https://img.ezwelfare.net/welfare_upload/popup/img/2023/03/230310_korcham_popup.png-->
            <li>
              <button type="button" aria-label="위험상품차단시스템 운영매장" @click="ImageFileOpen('DANGER-PRODUCT')">
                <img src="@/assets/images/pc/main-hcon/mark-danger.png" alt="위험상품차단시스템 운영매장"/>
              </button>
            </li>
            
            <!-- TODO 아이콘 클릭 시 팝업호출 & 아이콘 오버 시 풍선글 노출-->
            <li>
              <button type="button" aria-label="대량문자 전송자격 인증서" @click="ImageFileOpen('SMS')">
                <img src="@/assets/images/pc/main-hcon/mark-text.png" alt="대량문자 전송자격 인증서"/>
              </button>
              <!-- tooltip클래스에  closeToWall 추가하면 오른쪽으로 툴팁 스타일 변경됨 -->
              <div class="tooltip">
                <span class="tooltip-tit">
                  정보보호관리체계인증(ISMS) 인증범위<br />
                  복지몰 서비스 운영(온라인복지몰, 웰트리,<br />
                  온누리전통시자, 이지웰pay, 지역몰, B2B몰)<br />
                </span>
                <span class="expiration-date">
                  유효기간 2022.12.21 ~ 2025.12.20
                </span>
              </div>
            </li>

            <!-- TODO 아이콘 클릭 시 팝업호출 & 아이콘 오버 시 풍선글 노출-->
            <li>
              <button type="button" aria-label="선불충전금 보호조치" @click="ImageFileOpen('PREPAID-FUNDS')">
                <img
                  src="@/assets/images/pc/main-hcon/mark-secu.png"
                  alt="선불충전금 보호조치"
                />
              </button>
            </li>

          </ul>
        </div>
      </div>
    </div>
  </footer>
  <HconTncInfoPopup v-if="tncInfoPopupOpen" :tncInfo="tncReq" @open="tncInfoPopupOpen = true" @close="tncInfoPopupOpen = false">
    <Terms1003 v-if="hcTncKndCd === HcTncKndCd.KND_1003" :isTermsPopupOpen="tncInfoPopupOpen"></Terms1003>
    <Terms1002 v-if="hcTncKndCd === HcTncKndCd.KND_1002" :isTermsPopupOpen="tncInfoPopupOpen"></Terms1002>
    <Terms1001 v-if="hcTncKndCd === HcTncKndCd.KND_1001" :isTermsPopupOpen="tncInfoPopupOpen"></Terms1001>
  </HconTncInfoPopup>
</template>

<script setup lang="ts">
import HconDropDown from '@/components/com/HconComPCDropDown.vue' 
import HconTncInfoPopup from '@/components/popup/HconTncInfoPopup.vue'
import Terms1001 from '@/components/popup/terms/1001Terms.vue'
import Terms1002 from '~/components/popup/terms/1002Terms.vue'
import Terms1003 from '@/components/popup/terms/1003Terms.vue'
import { HcTncUsePntmCd, HcTncKndCd } from '~/types/common/tnc-enum-types';

// 약관 내용 팝업 변수 값
const tncInfoPopupOpen = ref(false);

// 약관종류코드
const hcTncKndCd = ref('')

// 약관 내용 팝업 요청 값
const tncReq = ref<any>({})

// 약관 내용 팝업 팝업 
const handlePopup = (value:any) => {
  tncInfoPopupOpen.value = true
  hcTncKndCd.value = value
  tncReq.value = {
    hcTncKndCd : value, // 1001: 서비스 이용약관 1002: 전자금융거래 이용 약관 1003: 개인정보처리방침
    hcTncKndCdNm: hcTncKndCd.value === HcTncKndCd.KND_1001 ? 'Hcon 몰 서비스 이용약관' : hcTncKndCd.value === HcTncKndCd.KND_1002 ? '전자금융거래약관' : hcTncKndCd.value === HcTncKndCd.KND_1003 ? '개인정보처리방침' : '',
    hcTncUsePntmCd: HcTncUsePntmCd.DISPLAY_MAIN, // 전시메인
    customClass: hcTncKndCd.value === HcTncKndCd.KND_1001 ? 'custom-popup mx-wd1000 terms-ts' : hcTncKndCd.value === HcTncKndCd.KND_1002 ? 'custom-popup mx-wd1000 terms-el' : hcTncKndCd.value === HcTncKndCd.KND_1003 ? 'custom-popup mx-wd1000 terms-pv' : 'custom-popup mx-wd1000'
  }
  
}

const familyOptionList = [
  { text: '현대이지웰', link: 'https://www.hyundaiezwel.com/renew/main.ez'},
  { text: '현대백화점그룹', link: 'https://www.ehyundai.com/newPortal/group/MAIN.do'},
  { text: '현대백화점', link: 'https://www.ehyundai.com/newPortal/index.do'},
  { text: '현대홈쇼핑', link: 'https://www.hmall.com/md/dpl/index'},
  { text: '현대그린푸드', link: 'https://hyundaigreenfood.com/po/INDEX.hgc'},
  { text: '현대캐터링시스템', link: 'https://www.hyundaicatering.com:525'},
  { text: 'C&S푸드시스템', link: 'http://www.cnsfoodsystem.co.kr'},
  { text: '한섬', link: 'https://www.handsome.co.kr/ko/main.do'},
  { text: '현대리바트', link: 'https://www.hyundailivart.co.kr/index'},
  { text: '현대L&C', link: 'https://www.hyundailnc.com/'},
  { text: '현대백화점면세점', link: 'https://www.hddfs.com/shop/dm/main.do'},
  { text: '현대드림투어', link: 'https://www.hyundaidreamtour.com/home/web/index.nhd'},
  { text: '현대렌탈케어', link: 'https://www.hyundairentalcare.com/'},
  { text: '현대퓨처넷', link: 'https://hyundaifuturenet.com/index.do'},
  { text: '에버다임', link: 'https://www.everdigm.com/main/'},
  { text: '현대바이오랜드', link: 'https://www.hyundaibioland.co.kr/main'},
  { text: '현대백화점그룹사회복지재단', link: 'https://www.ehyundai.com/newPortal/sc/main/main.do'},
  { text: '현대지에프홀딩스', link: 'https://www.ehyundai.com/newPortal/group/HLDS/MN000001.do'},
  { text: '벤디스', link: 'https://sikdae.com/'},
  { text: '온누리전통시장몰', link: 'https://www.onnuri-sijang.com/onnuri/main'},
]

const ImageFileOpen = (mark:string) => {

  const s3BaseUrl = useRuntimeConfig().public.hcon.cdn.contentsBase; //'https://contents-oneday-dev.ezwelfare.net';

  const filePath = ref('')

  // 정보보호관리체계인증(ISMS)
  if(mark === 'ISMS') {
    filePath.value = '/ezwel-image/welfare_upload/popup/img/2020/05/200522_cadmisms_popup.jpg'
  }
  // ISO 27001 인증(경로 확인)
  else if(mark === 'ISO-27001') {
    filePath.value = '/ezwel-image/welfare_upload/popup/img/2025/07/iso227001_popup.jpg'
  }
  // 위험상품차단시스템 운영매장(명칭 확인)
  else if(mark === 'DANGER-PRODUCT') {
    filePath.value = '/ezwel-image/welfare_upload/popup/img/2023/03/230310_korcham_popup.png'
  }
  // 대량문자 전송자격 인증서
  else if(mark === 'SMS') {
    // TODO 경로 미정
    filePath.value = '/ezwel-image/welfare_upload/popup/img/'
  }
  // 선불충전금 보호조치
  else if(mark === 'PREPAID-FUNDS') {
    // TODO 경로 미정
    filePath.value = '/ezwel-image/welfare_upload/popup/img/'
  }

  const imgFilePath = s3BaseUrl + filePath

  window.open(imgFilePath, '', 'width=505, height=705');
}
</script>